import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["permissionTitle"];

  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const signUpParamValue = urlParams.get('signup') || null;

    // Set the value of the hidden field
    this.permissionTitleTarget.value = signUpParamValue;

    console.log('signup parameter:', signUpParamValue);
  }
}
